import type { ReactNode } from 'react';

// The top of every screen, as the design draws it: a small uppercase kicker naming the section, the
// title, an optional line of what the screen holds, and the screen's actions to the right — then the
// 2px rule. One component so every screen opens the same way.

export function PageHeader({
  kicker,
  title,
  meta,
  actions,
}: {
  kicker: string;
  title: ReactNode;
  meta?: ReactNode;
  actions?: ReactNode;
}) {
  return (
    <div className="flex flex-col gap-4 border-b-2 border-divider pb-5">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div className="flex flex-col gap-1">
          <span className="kicker">{kicker}</span>
          <h1 className="text-[28px] text-ink">{title}</h1>
          {meta ? <p className="text-sm text-muted">{meta}</p> : null}
        </div>
        {actions ? <div className="flex flex-wrap gap-3">{actions}</div> : null}
      </div>
    </div>
  );
}
